import { defineComponent as a, createBlock as n, openBlock as i, mergeProps as s, unref as e, withCtx as m, createVNode as c } from "vue";
import p from "./Button.vue2.js";
import { XmarkIcon as f } from "../packages/icons/dist/esm/icons/xmark-icon.js";
import { useOUIAProps as u } from "../helpers/ouia.js";
const k = /* @__PURE__ */ a({
  name: "PfCloseButton",
  __name: "CloseButton",
  setup(r) {
    const o = r, t = u({ id: o.ouiaId, safe: o.ouiaSafe });
    return (l, _) => (i(), n(p, s(e(t), {
      variant: "plain",
      "aria-label": "Close"
    }), {
      icon: m(() => [
        c(e(f))
      ]),
      _: 1
    }, 16));
  }
});
export {
  k as default
};
